module.exports = __webpack_public_path__ + "img/scale-02.7eb26e66.svg";